import { render } from "./ModelActive.vue?vue&type=template&id=333cefed"
import script from "./ModelActive.vue?vue&type=script&lang=js"
export * from "./ModelActive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__